export { default as WorkbenchSettingsComponent } from './workbench-settings.component';
export * from './components';